import produce from 'immer';
export var getInitialState = function () { return ({
    loading: false,
    updating: false,
    error: false,
    storage: [],
    files: [],
    filesMeta: {},
}); };
function statesReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'LOAD_STORAGE_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'LOAD_STORAGE_SUCCESS':
                state.loading = false;
                state.error = false;
                state.storage = action.storage || [];
                break;
            case 'LOAD_STORAGE_FAILURE':
                state.loading = false;
                state.error = true;
                state.storage = [];
                break;
            case 'CREATE_STORAGE_ITEM_REQUEST':
            case 'UPDATE_STORAGE_ITEM_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'CREATE_STORAGE_ITEM_SUCCESS':
            case 'UPDATE_STORAGE_ITEM_SUCCESS':
                state.loading = false;
                state.error = false;
                state.storage = action.storage || [];
                break;
            case 'CREATE_STORAGE_ITEM_FAILURE':
            case 'UPDATE_STORAGE_ITEM_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'DELETE_STORAGE_ITEM_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'DELETE_STORAGE_ITEM_SUCCESS':
                state.loading = false;
                state.error = false;
                state.storage = state.storage.filter(function (l) { return l.id !== action.storageId; });
                break;
            case 'DELETE_STORAGE_ITEM_FAILURE':
                state.loading = false;
                state.error = action.error;
                break;
            case 'STORAGE_LOAD_FILES_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'STORAGE_LOAD_FILES_SUCCESS':
                state.files = action.files || [];
                state.filesMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case 'STORAGE_LOAD_FILES_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            default:
                break;
        }
    });
}
export default statesReducer;
